import React, { useState, useEffect } from 'react'
import { T, Avatar } from './ui'
import { isFav, toggleFav, favList } from './favorites'

// A tappable follow star — adds/removes a player from favorites (and the alert watchlist).
export function FavStar({ player, size = 22 }) {
  const id = player && (player.gsis_id || player.gsis)
  const [on, setOn] = useState(isFav(id))
  useEffect(() => { setOn(isFav(id)) }, [id])
  if (!id) return null
  return (
    <button onClick={(e) => { e.stopPropagation(); toggleFav(player); setOn(isFav(id)) }}
      title={on ? 'Following — you’ll get alerts' : 'Follow for alerts'}
      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: size, lineHeight: 1,
        padding: 4, color: on ? T.amber : T.faint, flexShrink: 0 }}>{on ? '★' : '☆'}</button>
  )
}

// "Your Players" — a quick-access row of followed players, each tappable to open. Refreshes live as
// favorites change (brkr-favs event). Hidden when the user follows nobody.
export function YourPlayers({ onPlayer }) {
  const [list, setList] = useState(favList())
  useEffect(() => {
    const h = () => setList(favList())
    window.addEventListener('brkr-favs', h)
    return () => window.removeEventListener('brkr-favs', h)
  }, [])
  if (!list.length) return null
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase', color: T.muted, marginBottom: 8 }}>
        ★ Your players <span style={{ color: T.faint, fontWeight: 600, textTransform: 'none', letterSpacing: 0 }}>· tap to open · alerts on</span>
      </div>
      <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4 }}>
        {list.map(p => (
          <button key={p.gsis_id} onClick={() => onPlayer && onPlayer({ gsis_id: p.gsis_id, full_name: p.name, team: p.team, pos: p.pos })}
            style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 8, background: T.card,
              border: `1px solid ${T.border}`, borderRadius: 999, padding: '7px 13px 7px 8px', cursor: 'pointer', color: T.text }}>
            <Avatar name={p.name} size={24} />
            <span style={{ fontSize: 13, fontWeight: 800, whiteSpace: 'nowrap' }}>{p.name}</span>
            <span style={{ fontSize: 10.5, color: T.muted, whiteSpace: 'nowrap' }}>{p.pos || ''} {p.team}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
